import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import PageLayout from '@/components/PageLayout'
import Header from '@/components/Header'
import Back from '@/components/Back'
export default React.memo(function BindEmail() {
    const { t } = useTranslation()
    const navigate = useNavigate()

    return (
        <PageLayout tabbarPage={true}>
            <Header
                leftChildren={<Back />}
                centerChildren={<div className="text-3.75 font-medium text-black">{t('绑定邮箱')}</div>}
            />
            <div className='px-6 py-6'></div>
        </PageLayout>
    )
})